import * as React from 'react';
import { classNames } from '~/utils/classNames';

type Variant = 'primary' | 'secondary' | 'warning' | 'danger';

interface LabelBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: Variant;
}

const baseClasses =
  'inline-flex cursor-default items-center rounded-full border border-bolt-ds-borderOutline px-2.5 py-0.5 text-xs font-semibold transition-colors focus-visible:outline-2';

const variantClasses: Record<Variant, string> = {
  primary: 'border-bolt-ds-brand border-transparent bg-bolt-ds-brand/10 text-bolt-ds-brand',
  secondary: 'border-transparent bg-bolt-ds-inverseSurface/10 text-bolt-ds-textPrimary',
  warning: 'border-transparent bg-bolt-ds-warningContainer/10 text-bolt-ds-warning',
  danger: 'border-transparent bg-bolt-ds-dangerContainer/10 text-bolt-ds-danger',
};

export const LabelBadge = React.forwardRef<HTMLDivElement, LabelBadgeProps>(
  ({ className, variant = 'primary', ...props }, ref) => {
    return <div ref={ref} className={classNames(baseClasses, variantClasses[variant], className)} {...props} />;
  },
);
